import { useQuery } from '@tanstack/react-query';
import { codeQueryKeys } from './codeQueryKeys.js';
import { storeableCodeHighlights } from '../code.config.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';
import { simpleHashString } from '@fabric-app/utils/text';
import { LowlightWorkerManager } from '../managers/LowlightWorkerManager.js';

const useQueryCodeLowlightHTML = (codeRequest, queryOptions) => {
  const cacheOptions = codeRequest && "code" in codeRequest && codeRequest.code.length <= storeableCodeHighlights ? {} : {
    persister: void 0,
    staleTime: 0,
    gcTime: 0,
    placeholderData: void 0,
    initialData: void 0
  };
  return useQuery({
    queryKey: !codeRequest ? codeQueryKeys.fromHash() : "url" in codeRequest ? codeQueryKeys.fromUrl(codeRequest.url) : codeQueryKeys.fromHash(simpleHashString(codeRequest.code)),
    queryFn: async () => {
      if (!codeRequest) throw new Error("codeRequest is required");
      const manager = LowlightWorkerManager.getInstance();
      const worker = manager.getWorker();
      const response = await worker.postMessage("parse", codeRequest, {
        timeout: 1e3 * 20
      });
      return response;
    },
    ...queryOptions,
    // This can be very large so best not to cache it until we have a proper cache clearing strategy
    // Unless the code is small enough to store in the cache
    ...cacheOptions,
    enabled: isQueryEnabled([
      queryOptions?.enabled,
      !!codeRequest
    ])
  });
};

export { useQueryCodeLowlightHTML };
//# sourceMappingURL=useQueryCodeLowlightHTML.js.map
